<template lang="pug">
	.campaign-streaming-card(v-if="record")
		.flex-col.streaming-card
			.flex-row.space.align-center.justify
				.flex-row.space-medium.align-center
					.img
						.img-holder(:style="{ backgroundImage: `url('${record.ImageUrl}')` }")
					.flex-col
						.streaming-name {{record.Name}}
						a(v-if="record.Url", :href="record.Url", target="_blank") {{$Data.limitText(record.Url, 50)}}
				.flex-row
					slot(name="actions-right")
			.flex-row.justify.dates.space-large.nowrap
				.font-big {{$Data.formatNumber(record.Reach, 'fixedPoint')}} {{$tCaption('impressions')}}
				.flex-col(v-if="getAdRunType(record.AdRunType)")
					.upper.font-small.grey {{$tCaption('Run type')}}
					span {{getAdRunType(record.AdRunType)}}
			.bottom-part.flex-col
				.flex-row.justify.margin-top.upper.bold
					span {{getSeconds(record.Duration)}} {{$tCaption('seconds')}}
					span(v-if="record.RatingMethod === 4") {{getRatingMethod(record.RatingMethod)}} {{$Data.formatNumber(record.RatePrice, '#0.##')}}$							
				.price.flex-row.margin-top.align-center.space-large(v-if="agreedPrice", :class="['center']")
					.agreed-price ${{$Data.formatNumber(agreedPrice , 'fixedPoint', 2)}}
				.flex-row.center.align-center.margin-top
					slot(name="actions")
				
</template>

<script>	
	import { RATING_METHODS, AD_RUN_TYPES } from 'app-core/constants';

	export default {
		translationCategory: 'proposal.StreamingsSelection',
		name: 'streamings-selection',
		components: {},		
		props: ['record'],
		data() {
			return {
				adPlacements: AD_RUN_TYPES.toLocale('name', this),
				ratingMethods: RATING_METHODS.toLocale('name', this)
			};
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.streamingCard = this;
		},
		computed: {
			agreedPrice() {
				return (this.record.RatingMethod === 4 ? ((this.record.Reach / 1000) * this.record.RatePrice) : this.record.RatePrice) || null;
			}
		},
		methods: {
			getSeconds(ms) {
				return parseInt(ms/1000);
			},
			getRatingMethod(id) {
				const item = this.ratingMethods.filter(f => f.id === id)[0];
				return item && item.name;
			},
			getAdRunType(id) {
				const item = this.adPlacements.filter(f => f.id === id)[0];
				return item && item.name;
			}
		}
	};
</script>
<style lang='scss'>
	.campaign-streaming-card {
		@import "main/themes/generated/variables.base.scss";

		.streaming-card {
			min-width: 240px;
			background: #ffffff;
			border-radius: 4px;
			color: #000;
			position: relative;
			transition: 0.5s;

			.bottom-part {
				transition: 0.5s;
				background: rgba(0, 0, 0, 0);
			}

			.dates {
				transition: 0.5s;
				background: rgba(0,0,0,0.04);
				padding: 10px;
				margin-top: 10px;
				border-bottom: 2px solid #f2f2f2;
			}

			> * {
				padding: 0px 10px;

				&:first-child {
					padding-top: 10px;
				}

				&:last-child {
					padding-bottom: 10px;
				}
			}

			.margin-top {
				margin-top: 20px;
			}

			.bold {
				font-weight: 600;
			}

			.img-holder {
				height: 60px;
				width: 80px;

				background-size: cover;
				background-position: center;
				border-radius: 4px;
			}

			.price {
				font-size: 24px;
				font-weight: 100;
				color: #00bf06;

				> .old-price {
					color: #ff0000ba;
					text-decoration: line-through;
				}
			}

			.dto {
				position: absolute;
				top: -20px;
				right: -20px;
				border-radius: 100px;
				background: #ff4343;
				padding: 8px;
				width: 60px;
				height: 60px;
				line-height: 2.3;
				text-align: center;
				font-size: 20px;
				font-weight: 100;
				color: #fff;
			}

			.streaming-name {
				font-weight: 100;
				font-size: 18px;
			}
		}
	}
</style>
